/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templates_BackInputs */



/**
* | output |
* | --- |
* | "Back to templates" |
*
* @param {Settings_Templates_BackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_back = /** @type {((inputs?: Settings_Templates_BackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_BackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Terug naar templates")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour aux modèles")
	return /** @type {LocalizedString} */ ("Back to templates")
});